// extracted by mini-css-extract-plugin
export default {"container":"link_container__Rb7-F","link":"link_link__Al9TO","underline":"link_underline__OFv+o","ripple":"link_ripple__MGJZW","dropdown":"link_dropdown__PCHOR"};